import React from 'react';
import { Helmet } from 'react-helmet-async'; // Import Helmet
import ContactForm from '../components/ContactForm';

const ContactPage: React.FC = () => {
  return (
    // Use a specific class for the page
    <div className="contact-page">
      <Helmet>
        <title>Contact Us | Get in Touch | IntelPro</title>
        <meta name="description" content="Contact IntelPro to discuss your business improvement needs. Fill out our form or find our contact details here." />
      </Helmet>
      {/* Add the inner container for consistent layout */}
      <div className="container">
        <h1>Contact Us</h1>
        <p className="page-intro"> {/* Optional: Use a class for intro text */}
          Have questions or want to learn more about how we can help your business? Fill out the form below and we’ll get back to you!
        </p>
        <ContactForm />
      </div>
    </div>
  );
};

export default ContactPage;